/**
* Created by elmer on 29/06/17.
*/
<template>
    <Row type="flex">
        <i-col :xs="24">
            <h1 class="mb15" style="color: #9b9b9c;">
                <Icon type="ios-keypad-outline" size="25" color="#9b9b9c" style="font-weight: bold;"></Icon>
                Listado de campañas
            </h1>
            <Row type="flex" :gutter="15">
                <i-col v-for="campaign in $store.state.campaigns" :xs="12" :md="4" :key="`col_campaign_${campaign.id}`">
                    <dashboard-card class="mb30" :title="campaign.titulo" :description="campaign.descripcion || ''" route="/admin/detail" @click="selectCampaign(campaign)"></dashboard-card>
                </i-col>
            </Row>
        </i-col>
    </Row>
</template>

<script>
  import DashboardCard from '@/components/DashboardCard';

  export default {
    components: {
      'dashboard-card': DashboardCard,
    },
    data() {
      return {};
    },
    beforeCreate() {
      this.$store.dispatch('campaigns');
    },
    methods: {
      selectCampaign(campaign) {
        this.$store.commit('setCampaign', campaign);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// PublicidadList.vue?47be29fb